import {isEmpty} from 'lodash';

export const getUndefinedIfEmpty = <T>(value: T): undefined | T =>
  isEmpty(value) ? undefined : value;
